import agent from './agent';
import config from '../config.json';
import ServiceBase from './ServiceBase';

const baseUrl = config.baseUrl2;
const service = 'batterycontrol';

class BatteryStateService extends ServiceBase {
    /**
     * get last known state of all batteries
     * @returns {Promise}
     */
    getStates = () => {
        const url = `${baseUrl}/${service}/batteries/state`;
        const config = { headers: { Authorization: `Bearer ${this.getToken()}` } };
        return agent.get(url, config);
    };
}

const batteryStateService = new BatteryStateService();
export default batteryStateService;
